import React, { Component } from "react";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import Select from "react-select";
import { addApp, updateApp } from '../../../../../../../actions/sceneActions'
import { customClass, getInitialRoute, stripTrailingSlash } from '../../../../../../../utils'
import $ from "jquery"
import {
  Card,
  Button,
  Row,
  Col,
  Form,
} from "react-bootstrap";
import moment from 'moment';
import { DISPLAY_APPS_SUCCESS_SAVE, SUCCESS_TEXT } from "../../messageText";

import { DisplayCounter } from "../../../_metronic/_partials";
import { NavigationHeader } from "../../../_metronic/layout/components/navigationheader/NavigationHeader";

const countDownFormatOptions = [
  { value: "1", label: "Hours, minutes & seconds" },
  { value: "2", label: "Days, hours, minutes & seconds" },
  { value: "3", label: "Days, hours & minutes" },
  { value: "4", label: "Days & hours" },
  { value: "5", label: "Only days" },
];
const timerTypeOptions = [
  { value: "1", label: "Count Down Timer" },
  { value: "2", label: "Count Up Timer" },
];
const themeOption = [
  { value: "tb_dark", label: "Dark" },
  { value: "tb_light ", label: "Light" },
];
class Countdown extends Component {
  state = {
    loader: false,
    date: new Date(),
    countDownFormat: "1",
    completionMessage: "",
    timerType: "1",
    timerLabel: "",
    theme: "tb_dark",
    updateApi: false,
    buttonDis: false,
    stateChanged: false,
  };

  componentDidMount() {
    const { scenes, location } = this.props;
    const { app_data } = scenes.updateSceneData;

    if (app_data) {
      const { completionMessage, countDownFormat, date, timerType, theme, timerLabel } = app_data;
      if (date && countDownFormat && location.pathname.includes('update')) this.setState({ timerLabel: timerLabel, completionMessage, countDownFormat, date: new Date(date), timerType, updateApi: true, theme });
    }
  }

  onTimerSave = (event) => {
    const { param } = this.props;
    this.setState({buttonDis:true, loader:true })
    const {
      timerType,
      completionMessage,
      date,
      countDownFormat,
      timerLabel,
      theme
    } = this.state;
    this.state.updateApi ?
      this.props.updateApp(
        param.contentMixId,
        this.props.scenes.updateSceneData.id,
        { timerType, completionMessage, date, countDownFormat, timerLabel, theme },
        5,
        this.onSaveCallBack
      ) :
      this.props.addApp(
        param.contentMixId,
        param.positionID,
        { timerType, completionMessage, date, countDownFormat, timerLabel, theme },
        timerType==1 ? "Count Down Timer" : "Count Up Timer",
        5,
        this.onSaveCallBack
      );
  };

  onBack = (event) => {
    const { params } = this.props.match;
    const { pathname } = this.props.location; 

    if (!this.state.stateChanged) {
      this.props.history(stripTrailingSlash(pathname,params))
      return;
    }

    Swal.fire({
      title: "Are you sure?",
      text: "Your changes have not been saved. Do you want to save before you leave the page?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Save",
      cancelButtonText: "Discard Changes",
      reverseButtons: true,
      customClass: customClass

    }).then((result) => {
      if (result.value) {
        this.onTimerSave()
      } else if (result.dismiss === "cancel") {
        this.props.history(stripTrailingSlash(pathname,params))
      }
    });
  };

  onSaveCallBack = () => {
    const { params } = this.props.match;
     Swal.fire({
      title: SUCCESS_TEXT,
      text: DISPLAY_APPS_SUCCESS_SAVE,
      type: "success",
      icon: "success",
      showConfirmButton: false,
      timer: 3000,
    }).then((result) => {
      this.setState({buttonDis:false, loader:false })
      this.props.history(`/studio/${params.wallId}`);
    });
  };

  onTextUrl = (event) => {
    this.setState({ completionMessage: event.target.value,stateChanged: true });
  };

  onChangeTimerLabel = (event) => {
    this.setState({ timerLabel: event.target.value,stateChanged: true });
  };

  onChangeTheme = (event) => {
    this.setState({ theme: event.value,stateChanged: true });
  };

  changedate = (event) => {
    this.setState({ date: new Date(event.target.value),stateChanged: true });
  };

  changeCountDownFormat = (event) => {  
    this.setState({ countDownFormat: event.value,stateChanged: true });
  };

  changeTimerType = (event) => {
    this.setState({ timerType: event.value,stateChanged: true });
  };

  render() {
    const { match, name } = this.props;
    const {
      date,
      countDownFormat,
      completionMessage,
      timerType,
      timerLabel,
      theme,
      buttonDis,
      loader,
      updateApi
    } = this.state;
    const { pathname } = this.props.location;

    return (
      <>
      { !updateApi ?
        <NavigationHeader
              name={name}
              backToNavigation={`${pathname ? stripTrailingSlash(pathname,match) : ''}`}
          /> : null }
        <div className="container-fluid subheader_content">
          <Card className="select_wall mb-3 rounded-0 border-0">
            <Card.Body className="p-0">
              <Row>
                <Col lg={4} className="border-right-lg">
                  <Card className="border-0 rounded-0">
                    <Card.Body className="p-4 card_height">
                      <Form>
                        <Form.Group className="form-group" controlId="timer-option">
                          <Form.Label>Timer Type</Form.Label>
                          <Select
                            value={timerTypeOptions.find(option => option.value === timerType)}
                            onChange={this.changeTimerType}
                            options={timerTypeOptions}
                          />
                        </Form.Group>
                        <Form.Group className="form-group" controlId="timer-format">
                          <Form.Label>Timer Format</Form.Label>
                          <Select
                            value={countDownFormatOptions.find(option => option.value === countDownFormat)}
                            onChange={this.changeCountDownFormat}
                            options={countDownFormatOptions}
                          />
                        </Form.Group>
                        <Form.Group className="form-group" controlId="timer-label">
                          <Form.Label>
                            {timerType === "1"
                              ? "Countdown Heading"
                              : "Count Up Heading"}
                          </Form.Label>
                          <Form.Control
                            type="text"
                            autoComplete="off"
                            value={timerLabel}
                            className="text-url-update"
                            placeholder="Enter text i.e. Event will starts in..."
                            onChange={this.onChangeTimerLabel}
                          />
                        </Form.Group>
                        <Form.Group className="form-group" controlId="timer-time">
                          <Form.Label>Time</Form.Label>
                          <Form.Control
                            id="datetime-local-input"
                            type="datetime-local"
                            value={moment(date).format("YYYY-MM-DD[T]HH:mm")}
                            onChange={this.changedate}
                            isClearable={false}
                          />
                        </Form.Group>
                        <Form.Group className="form-group" controlId="timer-message">
                          <Form.Label>
                            {timerType === "1"
                              ? "Completion message"
                              : "Waiting Message"}
                          </Form.Label>
                          <Form.Control
                            type="text"
                            autoComplete="off"
                            value={completionMessage}
                            className="text-url-update"
                            onChange={this.onTextUrl}
                          />
                        </Form.Group>
                        <Form.Group className="form-group" controlId="theme-option">
                          <Form.Label>Theme</Form.Label>
                          <Select
                            value={themeOption.find(option => option.value === theme)}
                            onChange={this.onChangeTheme}
                            options={themeOption}
                          />
                        </Form.Group>
                      </Form>
                    </Card.Body>
                    <Card.Footer className="bg-transparent d-flex justify-content-end border-0 p-3">
                      <button className="btn btn-outline-dark me-3 btn-min-w" onClick={this.onBack}>
                        <span className="position-relative">Back</span>
                      </button>
                      <Button
                        variant="primary"
                        disabled={ buttonDis }
                        className={`btn btn-primary btn-min-w ${loader ? `spinner spinner-white spinner-right disabled` : null}`}
                        onClick={this.onTimerSave}
                        id="Studio_Countdown_App_Users"
                      >
                        Save
                    </Button>
                    </Card.Footer>
                  </Card>
                </Col>
                <Col
                  lg={8}
                  className="d-flex align-items-center justify-content-center"
                >
                  <Card className="border-0 card w-100">
                    <Card.Body className="border-0">
                      <div className="wall_view">
                        <div className="wall_view_wrapper">
                          <DisplayCounter
                            date={date}
                            countDownFormat={countDownFormat}
                            completionMessage={completionMessage}
                            timerType={timerType}
                            timerLabel={timerLabel}
                            theme={theme}
                          />
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </div>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    studioWall: state.studio.studioWall,
    scenes: state.scene,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addApp: (contentMixId, position, appContent, appName, appId, callBack) =>
      dispatch(
        addApp(contentMixId, position, appContent, appName, appId, callBack)
      ),
    updateApp: (contentMixId, sceneContentId, appContent, appId, callBack) =>
      dispatch(
        updateApp(contentMixId, sceneContentId, appContent, appId, callBack)
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Countdown);
